var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Horizontal',{attrs:{"layout":_vm.layoutType}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('h4',[_vm._v("ข้อมูล")])])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }